import { Form, Input, Checkbox } from "antd";
import { observer } from "mobx-react";
import { __, _i } from "../../../utils";
import { PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM } from ".";
import { PluginUpdateLicenseTelemetryDataModal } from "..";
const PluginUpdateTermFields = observer(({
  pluginUpdate
}) => {
  const {
    privacyProvider,
    privacyPolicy,
    allowsTelemetry,
    allowsAutoUpdates,
    allowsNewsletter,
    licenses: [firstLicense]
  } = pluginUpdate;
  return /*#__PURE__*/React.createElement(React.Fragment, null, allowsAutoUpdates && /*#__PURE__*/React.createElement(Form.Item, {
    name: "autoUpdates",
    valuePropName: "checked",
    style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM
  }, /*#__PURE__*/React.createElement(Checkbox, {
    style: {
      zoom: 0.8
    }
  }, _i(__("Updates containing bug fixes and new features will be downloaded and installed automatically."), {
    a: /*#__PURE__*/React.createElement("a", {
      href: privacyPolicy,
      target: "_blank",
      rel: "noreferrer"
    })
  }))), /*#__PURE__*/React.createElement(Form.Item, {
    name: "terms",
    valuePropName: "checked",
    required: true,
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the privacy policy!")
    }],
    style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM
  }, /*#__PURE__*/React.createElement(Checkbox, {
    style: {
      zoom: 0.8
    }
  }, _i(__("I allow to transfer technical data about this WordPress installation to the update server of %1$s and get latest announcements. This data is required for license activation and update functionality. I have read the {{a}}privacy policy{{/a}} of %1$s.", privacyProvider), {
    a: /*#__PURE__*/React.createElement("a", {
      href: privacyPolicy,
      target: "_blank",
      rel: "noreferrer"
    })
  }))), allowsTelemetry && /*#__PURE__*/React.createElement(Form.Item, {
    name: "telemetry",
    valuePropName: "checked",
    style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM
  }, /*#__PURE__*/React.createElement(Checkbox, {
    style: {
      zoom: 0.8
    }
  }, _i(__("I allow telemetry data about the use of this WordPress plugin to be collected in accordance with the %1$s {{a}}privacy policy{{/a}}. This data does not include any personal information about users of the plugin. Collected data ({{aDataExample}}open example of transmitted data{{/aDataExample}}) will be used to provide you with the best possible support and to improve the plugin.", privacyProvider), {
    a: /*#__PURE__*/React.createElement("a", {
      href: privacyPolicy,
      target: "_blank",
      rel: "noreferrer"
    }),
    aDataExample: /*#__PURE__*/React.createElement(PluginUpdateLicenseTelemetryDataModal, {
      license: firstLicense,
      linkWrapper: true
    })
  }))), allowsNewsletter && /*#__PURE__*/React.createElement(Form.Item, {
    name: "newsletter",
    valuePropName: "checked",
    style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM
  }, /*#__PURE__*/React.createElement(Checkbox, {
    style: {
      zoom: 0.8
    }
  }, _i(__("I would like to receive the %1$s newsletter with WordPress news, sales and product offers (approx. 1-2 per month) by email. I have read the %1$s {{a}}privacy policy{{/a}}. I know that I can unsubscribe from the newsletter at any time.", privacyProvider), {
    a: /*#__PURE__*/React.createElement("a", {
      href: privacyPolicy,
      target: "_blank",
      rel: "noreferrer"
    })
  }))), /*#__PURE__*/React.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: (prevValues, nextValues) => prevValues.newsletter !== nextValues.newsletter
  }, ({
    getFieldValue
  }) => getFieldValue("newsletter") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Item, {
    label: __("First name"),
    name: "firstName",
    style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM,
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your first name!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    label: __("Email"),
    name: "email",
    style: PLUGIN_UPDATE_FORM_LAYOUT_MARGIN_BOTTOM,
    required: true,
    rules: [{
      type: "email",
      required: true,
      message: __("Please enter your email address!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement("div", {
    className: "notice notice-info inline below-h2 notice-alt",
    style: {
      margin: 0
    }
  }, /*#__PURE__*/React.createElement("p", null, __("Please note that we will send you a confirmation e-mail. Only when you have clicked on the activation link in the email will you receive the newsletter."))))));
});
export { PluginUpdateTermFields };